<template>
  <div class="flex column pt100 pb100 flex-center">
    <img :src="src" v-if="showPic" :width="width" alt="">
    <div class="color_999 tac" v-html="text"></div>
  </div>
</template>

<script>
const commonPic = require('../assets/nodata.png');
export default {
  name: "no-data",
  props: {
    showPic: {
      type: Boolean,
      default: true
    },
    text: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '50%'
    },
    type: {
      type: String,
      default: 'zkjkfw'
    },
  },
  data() {
    return {
      common: commonPic,
      hzscb: require('@/page/hzscb/assets/暂无数据@3x.png'),//患者筛查表
      zkjkfw: require('@/assets/暂无数据@3x.png'),//专科健康服务,
      dhry: require('@/page/dhry/assets/暂无内容@2x.png'),
      ssjz: require('@/page/ssjz/assets/暂无手术信息@2x.png'),
      compat: require('@/assets/暂无就诊人信息@2x.png'),
      book: require('@/assets/暂无排班@2x.png')
    }
  },
  computed: {
    src() {
      return this[this.type];
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/plugins/no-data.vue